export default __webpack_public_path__ + "static/Efficacy-Hgb_increase-chart-LG@2x-3d96cb45d9511eb1ebf7e7451f976d85.png";